module.exports = __webpack_public_path__ + "img/BoneDiesOnBothSidesOfTheFractureZone.7bee0846.jpg";